import { AppShell } from '@/components/AppShell'
import { SettingsNav } from '@/components/SettingsNav'

/** Settings pages: full-height left nav + scrollable main. */
export function SettingsShell({ title, customerId, customerName, children }) {
  return (
    <AppShell
      title={title}
      sidebar={
        <div className="min-h-0 flex-1 overflow-y-auto">
          <SettingsNav customerId={customerId} customerName={customerName} />
        </div>
      }
    >
      {children}
    </AppShell>
  )
}
